import { Box, Typography, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonRow from "../CommonRow";
import { Images } from "./../../assets/common";
import "./index.scss";
import ApiService from "../../services/api-service";
import Loader from "./../../components/Loader";
import NoData from "./../../components/Nodata";
import { useTranslation } from "react-i18next";
export default function ChatMoreData({ playlistId, onClose }) {
  const { t } = useTranslation("common");
  const [topFiveTippers, settopFiveTippers] = useState([]);
  const [topFiveStreamers, settopFiveStreamers] = useState([]);

  const [loading, setLoading] = useState(false);

  const getTopFiveMostTipped = async (playlistId) => {
    setLoading(true);
    try {
      console.log("tipped");
      const response = await ApiService.GET_PLAYLIST_MOST_TIPPED(
        `playlistId=${playlistId}`
      );
      console.log(response["result"]);
      settopFiveTippers([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
    getTopFiveMostStreamed(playlistId);
  };

  const getTopFiveMostStreamed = async (playlistId) => {
    setLoading(true);
    try {
      const response = await ApiService.GET_PLAYLIST_MOST_STREAMED(
        `playlistId=${playlistId}`
      );
      settopFiveStreamers([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getTopFiveMostTipped(playlistId);
  }, []);
  return (
    <Box className="__chat_more_data">
      <Stack
        className="__chat_more_data_header"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        background="rgba(255, 255, 255, 0.05)"
      >
        <Typography className="fs-15">Top 5</Typography>

        <img
          title="Close"
          style={{ width: "12px", height: "12px" }}
          src={Images.arrow_down}
          className="_cp"
          onClick={() => onClose()}
          alt="close"
        />
      </Stack>
      <Stack
        className="__chat_more_data_box"
        sx={{ position: "relative" }}
        spacing={1}
      >
        <Box>
          {topFiveTippers && topFiveTippers.length > 0 ? (
            <Typography className="fs-13 fade-text my-10">
              Top 5 Tippers
            </Typography>
          ) : null}

          <Stack spacing={1}>
            {topFiveTippers &&
              topFiveTippers.map((tipper, index) => (
                <CommonRow row={tipper} key={index} />
              ))}
          </Stack>
        </Box>
        <Box>
          {topFiveStreamers && topFiveStreamers.length > 0 ? (
            <Typography className="fs-13 fade-text my-10">
              Top 5 Streamers
            </Typography>
          ) : null}

          <Stack spacing={1}>
            {topFiveStreamers &&
              topFiveStreamers.map((streamers, index) => (
                <CommonRow row={streamers} key={index} />
              ))}
          </Stack>
        </Box>
        {topFiveTippers &&
        topFiveStreamers &&
        topFiveTippers.length === 0 &&
        topFiveStreamers.length === 0 ? (
          <Box sx={{ position: "relative" }}>
            <NoData lable={t("noData.noData")} />
          </Box>
        ) : null}
        {loading ? (
          <Loader
            _class="__loader_inside"
            wait={true}
            message={t("loader.message8")}
          />
        ) : null}
      </Stack>
    </Box>
  );
}
